module.exports = __webpack_public_path__ + "img/1.9e599f59.jpg";